"use strict";

/**
 * @classdesc
 * Digitalisierungs-Modul-Panel.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.module Modul-Instanz
 */
gc.gis.module.GCDigitize.Panel = function(options)
{
	gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCDigitize);

	/**
	 * @type {gc.gis.module.GCDigitize}
	 * @private
	 */
	this._module = options.module;

	/**
	 * @type {gc.gis.widget.GCToggleSplitButton}
	 * @private
	 */
	this._drawTypeButton = null;
	/**
	 * @type {gc.gis.widget.GCRadioItem}
	 * @private
	 */
	this._selectButton = null;
	/**
	 * @type {gc.gis.widget.GCRadioItem}
	 * @private
	 */
	this._processingButton = null;

	var options_widget = {
		className: 'gc-digitize',
		toolbar: this._initToolbar(),
		actionbar: this._initActionbar()
	};

    gc.gis.widget.GCPanel.call(this, options_widget);

    // Panel erzeugen
	var options_panel = {
		module: this._module
	};
	this._panelDraw = new gc.gis.module.GCDigitize.DrawPanel(options_panel);
	this._panelDraw.getElement().hide();
	this._panelSelect = new gc.gis.module.GCDigitize.SelectPanel(options_panel);
	this._panelSelect.getElement().hide();
	this._panelGeoproc = new gc.gis.module.GCDigitize.GeoporcessingPanel(options_panel);
	this._panelGeoproc.getElement().hide();

	// Inhalt erzeugen
    this.element = this._render();
    this._initContent();
    this._initEvents();
};
gc.gis.module.GCDigitize.Panel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Liefert das Panel für für die Zeichnen-Eigenschaften.
 *
 * @public
 * @return {gc.gis.module.GCDigitize.DrawPanel}
 */
gc.gis.module.GCDigitize.Panel.prototype.getPanelDraw = function()
{
	return this._panelDraw;
};

/**
 * Liefert das Panel für die Geometrie-Auswahl.
 *
 * @public
 * @return {gc.gis.module.GCDigitize.SelectPanel}
 */
gc.gis.module.GCDigitize.Panel.prototype.getPanelSelect = function()
{
	return this._panelSelect;
};

/**
 * Liefert das Panel für das GeoProcessing.
 *
 * @public
 * @return {gc.gis.module.GCDigitize.GeoporcessingPanel}
 */
gc.gis.module.GCDigitize.Panel.prototype.getPanelGeoprocessing = function()
{
	return this._panelGeoproc;
};

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCDigitize.Panel.prototype._initContent = function()
{
	this.element_content
		.append(this._panelDraw.getElement())
		.append(this._panelSelect.getElement())
		.append(this._panelGeoproc.getElement());
};

/**
 * Initialisiert die Eventbehandlungsroutinen des Panels.
 *
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._initEvents = function()
{
	this._module.on(gc.gis.module.GCDigitizeEvent.DRAW_TYPE_CHANGED, this, function (evt) {
		this._onDrawTypeChanged(evt.type);
	});

	// Tracking-Layer überwachen
	this._module.on(gc.gis.module.GCDigitizeEvent.FEATURE_ADDED, this, function (evt) {
		this._onTrackingLayerUpdate(evt)
	});
	this._module.on(gc.gis.module.GCDigitizeEvent.FEATURE_REMOVED, this, function (evt) {
		this._onTrackingLayerUpdate(evt)
	});
	this._module.on(gc.gis.module.GCDigitizeEvent.LAYER_CLEARED, this, function (evt) {
		this._onTrackingLayerUpdate(evt)
	});
};

/**
 * Initialisiert die Toolbar.
 *
 * @method
 * @return {Object}
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._initToolbar = function()
{
	var items = [],
		self = this;

	this._drawTypeButton = new gc.gis.widget.GCToggleSplitButton({
		tooltip: 'Zeichenwerkzeug aktivieren/auswählen',
		options: [
			{
				label: 'Punkt',
				value: gc.gis.module.GCDigitizeConstants.DRAW_POINT,
				icon: 'ms ms-points'
			},
			{
				label: 'Linie',
				value: gc.gis.module.GCDigitizeConstants.DRAW_LINE,
				icon: 'ms ms-line'
			},
			{
				label: 'Fläche',
				value: gc.gis.module.GCDigitizeConstants.DRAW_POLYGON,
				icon: 'ms ms-polygon'
			},
			{
				label: 'Rechteck',
				value: gc.gis.module.GCDigitizeConstants.DRAW_RECTANGLE,
				icon: 'ms ms-vector'
			},
			{
				label: 'Kreis',
				value: gc.gis.module.GCDigitizeConstants.DRAW_CIRCLE,
				icon: 'ms ms-crosshair'
			}
			/*
			{
				label: 'Ellipse',
				value: gc.gis.module.GCDigitizeConstants.DRAW_ELLIPSE
			}
			*/
			/*
			{
				label: 'Text',
				value: gc.gis.module.GCDigitizeConstants.DRAW_TEXT
			}
			*/
		],
		click: function() {
			self._updateToolbar(this);
			self._onDrawTypeButtonClickedOrChanged();
		},
		change: function() {
			self._onDrawTypeButtonClickedOrChanged();
		}
	});
	this._drawTypeButton.setAction(new gc.gis.action.digitize.ToggleDrawMode(this._module, this, this._drawTypeButton));
	items.push(this._drawTypeButton);

	this._selectButton = new gc.gis.widget.GCRadioItem({
		group: 'gc_digitize_main_toolbar',
		label:  'Auswählen',
		tooltip: 'Auswahlwerkzeug',
		className: 'btn btn-default',
		icon: 'ms ms-select-arrow',
		active: false,
		click: function () {
			self._updateToolbar(this);
		}
	});
	this._selectButton.setAction(new gc.gis.action.digitize.ToggleSelectMode(this._module, this, this._selectButton));
	items.push(this._selectButton);

	this._processingButton = new gc.gis.widget.GCRadioItem({
		group: 'gc_digitize_main_toolbar',
		label:  'Verarbeiten',
		tooltip: 'Geometrieverarbeitungswerkzeuge',
		className: 'btn btn-default',
		icon: 'ms ms-processes',
		active: false,
		click: function () {
			self._updateToolbar(this);
		}
	});
	this._processingButton.setAction(new gc.gis.action.digitize.ToggleProcessingMode(this._module, this, this._processingButton));
	items.push(this._processingButton);

	return new gc.gis.widget.GCMenu({
		items: items
	});
};

/**
 * Initialisiert die Actionbar.
 *
 * @method
 * @return {Object}
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._initActionbar = function()
{
	var self = this;

	var btn_save = new gc.gis.widget.GCItem({
		label: 'Speichern',
		className: 'btn btn-success',
		icon: 'action-apply',
		click: function(evt) {
			try
			{
				if (this.isEnabled())
				{
					self._module.openSaveDialog();
				}
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});
	btn_save.setEnabled(false);

	var btn_export = new gc.gis.widget.GCItem({
		label: 'Exportieren',
		className: 'btn btn-primary',
		icon: 'item-zoom-to',
		click: function( evt ) {
			try
			{
				if (this.isEnabled())
				{
					self._module.openExportDialog();
				}
			}
			catch( err )
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});
	btn_export.setEnabled(false);

	// TODO Export-Button wieder einblenden und Funktionalität implementieren
	return new gc.gis.widget.GCMenu({
		containerClassName: 'actionbar',
		items: [
			btn_save
			// btn_export
		]
	});
};

/**
 * Aktualisiert die Toolbar in Abhängigkeit des ausgewählten Buttons.
 *
 * @method
 * @param {gc.gis.widget.GCItem} button aktueller Button
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._updateToolbar = function(button)
{
	if (this._drawTypeButton === button)
	{
		this._selectButton.setActive(false);
		this._processingButton.setActive(false);
	}

	if (this._selectButton === button)
	{
		this._drawTypeButton.setActive(false);
		this._selectButton.setActive(!this._selectButton.isActive());           // toggle
		this._processingButton.setActive(false);
	}

	if (this._processingButton === button)
	{
		this._drawTypeButton.setActive(false);
		this._selectButton.setActive(false);
		this._processingButton.setActive(!this._processingButton.isActive());   // toggle
	}
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Nutzer den Button zum Ändern des Zeichentype angeklickt oder
 * den Zeichentyp geändert hat.
 *
 * @method
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._onDrawTypeButtonClickedOrChanged = function()
{
	this._module.setDrawType(this._drawTypeButton.isActive() ? this._drawTypeButton.getValue() : null);
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn das Modul vermeldet, dass sich Zeichentyp geändert hat.
 *
 * @method
 * @param {number} type
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._onDrawTypeChanged = function(type)
{
	// Button deaktivieren (z.B. wenn Nutzer eine Geometrie vollst. eingzeichnet hat)
	if (null == type && this._drawTypeButton.isActive())
	{
		this._drawTypeButton.setActive(false);
	}

	// evtl. die Änderung des Geometrietyps implementiern, wird aber eigentlich nicht vom Modul gesetzt lediglich das
	// Deaktivieren des Zeichnenmodus spielt eine Rolle
};

/**
 * Aktualisiert die Benutzeroberfläche anhand des aktuellen Zustands des TrackingLayers.
 *
 * @method
 * @param {Object} evt
 * @private
 */
gc.gis.module.GCDigitize.Panel.prototype._onTrackingLayerUpdate = function(evt)
{
	/**
	 * @type {gc.gis.widget.GCItem[]}
	 */
	var buttons = this.actionbar.getItems();

	// Speicher- und Export-Button de- bzw. aktivieren
	buttons.forEach(function (btn) {
		btn.setEnabled(evt.numFeatures > 0);
		btn.setActive(evt.numFeatures > 0);
	});
};
